<h1 mat-dialog-title>Export Settings</h1>
<div mat-dialog-content>
  <mat-card>
    <mat-card-title>Output Format</mat-card-title>
    <mat-card-content>
      <form class="standard-form">
        <mat-form-field>
          <mat-label>File Type</mat-label>
          <mat-select name="results.fileType" [(ngModel)]="results.fileType">
            <mat-option [value]="0">CSV</mat-option>
            <mat-option [value]="1">JSON</mat-option>
            <mat-option [value]="2">PARQUET</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>
      <form class="standard-form">
        <mat-form-field>
          <mat-label>Destination Type</mat-label>
          <mat-select [(value)]="destinationId">
            <mat-option [value]="0">Email</mat-option>
            <mat-option [value]="1">SFtp</mat-option>
            <mat-option [value]="2">Azure Blob</mat-option>
            <mat-option [value]="3">AWS S3</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </mat-card-title>
    <mat-card-content>
      <ng-container *ngIf="destinationId == 0">
        <form class="standard-form">
          <mat-form-field>
            <mat-label>Notification Email</mat-label>
            <input matInput name="results.notificationEmail" [(ngModel)]="results.notificationEmail" />
          </mat-form-field>
          <!--<mat-form-field>
            <mat-label>Email Address</mat-label>
            <input matInput name="emailConfig.emailAddress" [(ngModel)]="emailConfig.emailAddress" />
          </mat-form-field>-->
        </form>
      </ng-container>
      <ng-container *ngIf="destinationId == 1">
        <form class="standard-form">
          <mat-form-field>
            <mat-label>Notification Email</mat-label>
            <input matInput name="results.notificationEmail" [(ngModel)]="results.notificationEmail" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Host</mat-label>
            <input matInput name="sftpConfig.host" [(ngModel)]="sftpConfig.host" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Port</mat-label>
            <input matInput type="number" name="sftpConfig.port" [(ngModel)]="sftpConfig.port" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Username</mat-label>
            <input matInput name="sftpConfig.userName" [(ngModel)]="sftpConfig.userName" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input matInput name="sftpConfig.password" [(ngModel)]="sftpConfig.password" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Remote Path</mat-label>
            <input matInput name="sftpConfig.path" [(ngModel)]="sftpConfig.path" />
          </mat-form-field>
        </form>
      </ng-container>
      <ng-container *ngIf="destinationId == 2">
        <form class="standard-form">
          <mat-form-field>
            <mat-label>Notification Email</mat-label>
            <input matInput name="results.notificationEmail" [(ngModel)]="results.notificationEmail" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Connection String</mat-label>
            <input matInput name="azureConfig.connectionString" [(ngModel)]="azureConfig.connectionString" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Container</mat-label>
            <input matInput name="azureConfig.containerName" [(ngModel)]="azureConfig.containerName" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Path</mat-label>
            <input matInput name="azureConfig.path" [(ngModel)]="azureConfig.path" />
          </mat-form-field>
        </form>
      </ng-container>
      <ng-container *ngIf="destinationId == 3">
        <form class="standard-form">
          <mat-form-field>
            <mat-label>Notification Email</mat-label>
            <input matInput name="results.notificationEmail" [(ngModel)]="results.notificationEmail" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Access Key</mat-label>
            <input matInput name="awsConfig.accessKey" [(ngModel)]="awsConfig.accessKey" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Secret Key</mat-label>
            <input matInput name="awsConfig.secretKey" [(ngModel)]="awsConfig.secretKey" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Region</mat-label>
            <input matInput name="awsConfig.region" [(ngModel)]="awsConfig.region" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Bucket</mat-label>
            <input matInput name="awsConfig.bucketName" [(ngModel)]="awsConfig.bucketName" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Path</mat-label>
            <input matInput name="awsConfig.path" [(ngModel)]="awsConfig.path" />
          </mat-form-field>
        </form>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onConfirmClick()">Submit Export</button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
